import React from 'react';

const SipCallingInclusions = (props) => {
  const {
    authorableContent: {
      planDescription,
      callInclusionsList,
    },
    callInclusionsText,
    handleSipInclusionShowAdvanceFeatures,
    sipInclusionShowList,
  } = props;
  return (
    <div className="col-md-8 col-sm-12 padding-text text-center">
      <div className="col-12">
        {planDescription}
      </div>
      <div className="col-12">
        <button type="button" className="btn btn-text" onClick={handleSipInclusionShowAdvanceFeatures}>
          {callInclusionsText}
          <i className={`td-icon ${sipInclusionShowList ? 'icon-ui-up-arrow-thick' : 'icon-ui-down-arrow-thick'}`} />
        </button>
      </div>
      {sipInclusionShowList && callInclusionsList.map(data => (
        <div className="col-12" key={data}>{data}</div>
      ))}
    </div>
  );
};

export default SipCallingInclusions;
